import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useHistory } from "react-router-dom";
import { sweetAlert } from "../Utils/SweetAlert";
import { ApiCallGateway } from "../Network/apiCallGateway";
import Cookies from "js-cookie";
import { USER_BASE_URL } from "../Network/urls/authUserUrl";

const SSOLogin = () => {
  const history = useHistory();

  const errorMessage = (error) => {
    console.log(error, "line 8");
  };
  const login = async (res) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("accept", "application/json");
      myHeaders.append("content-type", "application/json");
      var raw = JSON.stringify({
        credential: res.credential,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
        credentials: "include",
      };

      const response = await fetch(USER_BASE_URL, requestOptions);

      if (response.status === 200) {
        const result = await response.json();
        if (result) {
          // Cookies.set("access_token", result?.accessToken);
          localStorage.setItem(
            "loggedInUser",
            JSON.stringify(result?.user)
          );

          history.push({
            pathname: "/created",
            state: {
              userEmail: result?.user?.email,
              admin: result?.user?.admin,
            },
          });
          window.location.reload();
        } else {
          sweetAlert(
            "Oops...",
            "Invalid username or password",
            "error"
          );
        }
      } else {
        sweetAlert(
          "Oops...",
          "Something went wrong with the request",
          "error"
        );
      }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <div>
      <GoogleLogin onSuccess={login} onError={errorMessage} />
    </div>
  );
};
export default SSOLogin;
